// import { track } from "@amplitude/analytics-browser";
// import { IconClock24, IconGift, IconMessage } from "@tabler/icons-react";
// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import AuthModal from "./AuthModal";
// import HeroAnimation from "./HeroAnimation";
// import "./HeroSection.css";

// // Chat icon SVG (unchanged)
// const ChatIcon = () => (
//   <svg
//     viewBox="0 0 24 24"
//     width="20"
//     height="20"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M21 6H18V15H6V17C6 17.55 6.45 18 7 18H17L21 22V7C21 6.45 20.55 6 21 6ZM17 12V3C17 2.45 16.55 2 16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12Z"
//       fill="white"
//     />
//   </svg>
// );

// interface PhoneAuthHandlers {
//   requestOtp: (payload: {
//     phone: string;
//     firstName?: string;
//     lastName?: string;
//     email?: string;
//   }) => Promise<void>;
//   verifyOtp: (payload: {
//     phone: string;
//     otp: string;
//     firstName?: string;
//     lastName?: string;
//     email?: string;
//   }) => Promise<void>;
// }

// interface Msg91AuthHandlers {
//   verifyOtp: (payload: {
//     accessToken: string;
//     phone: string;
//     firstName?: string;
//     lastName?: string;
//     email?: string;
//   }) => Promise<void>;
// }

// interface HeroSectionProps {
//   user: any;
//   onGoogleSignIn: () => void;
//   phoneAuth?: PhoneAuthHandlers;
//   msg91Auth?: Msg91AuthHandlers;
// }

// const HeroSection: React.FC<HeroSectionProps> = ({
//   user,
//   onGoogleSignIn,
//   phoneAuth,
//   msg91Auth,
// }) => {
//   const originalFeatures = [
//     {
//       icon: <IconGift size={20} strokeWidth={2.5} />,
//       text: "Free Birth Chart & Astrology Report",
//     },
//     {
//       icon: <IconClock24 size={20} strokeWidth={2.5} />,
//       text: "24/7 AI Astrologer Chat & Call",
//     },
//     {
//       icon: <IconMessage size={20} strokeWidth={2.5} />,
//       text: "Get 1 Free Prediction Instantly",
//     },
//   ];

//   // Duplicate for seamless marquee effect
//   const marqueeFeatures = [...originalFeatures, ...originalFeatures];

//   const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

//   return (
//     <section className="hero-container">
//       {/* ===== 3D BACKGROUND ANIMATION ===== */}
//       <HeroAnimation />

//       {/* ===== BRAND-TINTED OVERLAY ===== */}
//       <div className="hero-overlay" />

//       {/* ===== CONTENT ===== */}
//       <div className="hero-content">
//         {/* SEO-Optimized Heading */}
//         <h1 className="hero-title">
//           Get the Most Accurate Astrology Predictions & Birth Chart Readings
//           only on <span className="brand-highlight">Aura AI</span>
//         </h1>

//         {/* <p className="hero-subtitle">
//           Aura AI has analyzed over <strong>1 million birth charts</strong> to deliver
//           <strong> highly personalized, accurate astrology predictions</strong>.
//           Understand your destiny and relationships like never before.
//         </p> */}

//         {/* NEW "Trained On" Data Highlights */}
//         <div className="data-highlights-container">
//           <p className="data-highlights-title">Our Aura AI Is Trained On</p>
//           <div className="data-highlights">
//             <div className="highlight-item">
//               <div className="highlight-number">1M+</div>
//               <div className="highlight-text">Birth Charts & Life Events</div>
//             </div>
//             <div className="highlight-item">
//               <div className="highlight-number">100+</div>
//               <div className="highlight-text">Top Astrologers' Logic</div>
//             </div>
//             <div className="highlight-item">
//               <div className="highlight-number">10,000+</div>
//               <div className="highlight-text">Classical Rules & Scriptures</div>
//             </div>
//           </div>
//         </div>

//         {/* CTA */}
//         {user ? (
//           <Link
//             to="/chat"
//             className="hero-cta-button chat-button"
//             onClick={() =>
//               track("Start Chat Clicked (Hero Section)", {
//                 source: "Hero Section",
//               })
//             }
//           >
//             <ChatIcon />
//             Start Chatting with Aura AI
//           </Link>
//         ) : (
//           <div className="hero-cta-area">
//             <button
//               className="hero-cta-button start-chat-button"
//               onClick={() => {
//                 track("Start Chatting Clicked (Hero Section)", {
//                   source: "Hero Section",
//                 });
//                 setIsAuthModalOpen(true);
//               }}
//             >
//               Start Free chatting with AuraAI
//             </button>

//             {/* New AuthModal Component */}
//             <AuthModal
//               isOpen={isAuthModalOpen}
//               onClose={() => setIsAuthModalOpen(false)}
//               onGoogleSignIn={onGoogleSignIn}
//               phoneAuth={phoneAuth}
//               msg91Auth={msg91Auth}
//             />
//           </div>
//         )}

//         {/* NEW Features Marquee */}
//         <div className="marquee-container">
//           <div className="marquee-content">
//             {marqueeFeatures.map((feature, index) => (
//               <div className="marquee-item" key={index}>
//                 {feature.icon}
//                 <span>{feature.text}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default HeroSection;
import { track } from "@amplitude/analytics-browser";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthModal from "./AuthModal";
import { useGuestChat } from "../hooks/useGuestChat";
import "./HeroSection.css";

// --- CONFIGURATION: PLANETS ---
// Update the 'gif' paths to point to your actual GIF files in the public folder
const PLANETS_DATA = [
  { name: "Rahu", label: "Rahu (Rahu)", gif: "/planets/Rahu.webp" },
  { name: "Mercury", label: "Mercury (Budh)", gif: "/planets/Mercury.webp" },
  { name: "Mars", label: "Mars (Mangal)", gif: "/planets/Mars.webp" },

  { name: "Jupiter", label: "Jupiter (Guru)", gif: "/planets/Jupiter.webp" },
  { name: "Sun", label: "Sun (Surya)", gif: "/planets/Sun.webp" },
  { name: "Venus", label: "Venus (Shukra)", gif: "/planets/Venus.webp" },

  { name: "Saturn", label: "Saturn (Shani)", gif: "/planets/Saturn.webp" },
  { name: "Moon", label: "Moon (Chandra)", gif: "/planets/Moon.webp" },

  { name: "Ketu", label: "Ketu (Ketu)", gif: "/planets/Ketu.webp" },
];

/* The hero chat card cycles through these. Every answer is written the way the
   product actually answers: it names the house, the graha and the dasha rather
   than giving a horoscope line, because that difference is the whole pitch. */
const CHAT_THREADS = [
  {
    q: "Should I change my job this year?",
    a: [
      "Saturn is transiting your 10th house and your Mercury antardasha starts in March, which usually shows up as a change in work rather than a loss of it.",
      "March to August looks strongest for a move. Before that, Saturn asks you to finish what you started.",
    ],
  },
  {
    q: "When will I get married?",
    a: [
      "Your 7th house lord is Venus, sitting in Rohini. You are running Jupiter mahadasha until 2027, and Jupiter aspects your 7th from the 11th.",
      "The strongest window is the Jupiter to Saturn antardasha, roughly late 2026 into 2027. Shall I check compatibility against a specific chart?",
    ],
  },
  {
    q: "मेरी शादी में देरी क्यों हो रही है?",
    a: [
      "आपके सप्तम भाव पर शनि की दृष्टि है और गुरु वक्री है, इसलिए विवाह में देरी स्वाभाविक है।",
      "2027 की गुरु-शुक्र अंतर्दशा सबसे अनुकूल समय दिखा रही है।",
    ],
  },
  {
    q: "Is this a good time to invest?",
    a: [
      "Your 2nd and 11th lords are both strong right now, but Rahu is in the 8th, which tends to reward patience over speed.",
      "Steady positions look better than leveraged ones until the Rahu antardasha ends.",
    ],
  },
];

/* The same card for the INTERNATIONAL pages (/usa, /uae), which render this
   hero unchanged. The Hindi thread above is right for India and wrong for a
   visitor in Texas, who saw a question they could not read in a demo meant to
   show what the product does.

   English throughout, and the India-specific framing swapped for questions
   that audience actually arrives with. The astrology vocabulary (house, lord,
   dasha) stays: it is the product's substance, not a regional flourish, and
   it is what the pages already explain at length. */
const CHAT_THREADS_INTL = [
  {
    q: "Should I change my job this year?",
    a: [
      "Saturn is transiting your 10th house and your Mercury antardasha starts in March, which usually shows up as a change in work rather than a loss of it.",
      "March to August looks strongest for a move. Before that, Saturn asks you to finish what you started.",
    ],
  },
  {
    q: "Is this relationship going anywhere?",
    a: [
      "Your 7th house lord is Venus in Rohini, and Jupiter aspects it from the 11th, which favours commitment over drift.",
      "The clearest window is late 2026 into 2027. Shall I read it against their chart as well?",
    ],
  },
  {
    q: "What do my three cards mean together?",
    a: [
      "Past is the Eight of Cups, present the Ten of Swords, future the Star. Read alone that looks bleak in the middle and fine at the end.",
      "Against your chart it is a Saturn period closing out, so the Ten of Swords is the ending you already decided on rather than one happening to you.",
    ],
  },
  {
    q: "Is this a good time to invest?",
    a: [
      "Your 2nd and 11th lords are both strong right now, but Rahu is in the 8th, which tends to reward patience over speed.",
      "Steady positions look better than leveraged ones until the Rahu antardasha ends.",
    ],
  },
];

const ChatIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 6H18V15H6V17C6 17.55 6.45 18 7 18H17L21 22V7C21 6.45 20.55 6 21 6ZM17 12V3C17 2.45 16.55 2 16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12Z"
      fill="white"
    />
  </svg>
);

interface PhoneAuthHandlers {
  requestOtp: (payload: {
    phone: string;
    firstName?: string;
    lastName?: string;
    email?: string;
  }) => Promise<void>;
  verifyOtp: (payload: {
    phone: string;
    otp: string;
    firstName?: string;
    lastName?: string;
    email?: string;
  }) => Promise<void>;
}

interface Msg91AuthHandlers {
  verifyOtp: (payload: {
    accessToken: string;
    phone: string;
    firstName?: string;
    lastName?: string;
    email?: string;
  }) => Promise<void>;
}

interface HeroSectionProps {
  user: any;
  onGoogleSignIn: () => void;
  phoneAuth?: PhoneAuthHandlers;
  msg91Auth?: Msg91AuthHandlers;
  /** Overrides the H1. /market reuses this hero, and two pages sharing one H1
      makes each a weaker answer for its own query, so it passes its own. */
  headingLead?: string;
  headingAccent?: string;
  /* Same reason as headingLead: /india is the paid-traffic landing page and
     leads with the privacy line instead of the method line. */
  points?: string[];
  /** Set on the geo-gated international pages (/usa, /uae). Swaps the demo
      chat for the English-only set: the default thread list contains a Hindi
      question, which a US visitor cannot read. */
  international?: boolean;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  user,
  onGoogleSignIn,
  phoneAuth,
  msg91Auth,
  headingLead = "AI Astrology Free Chat,",
  headingAccent = "Answered",
  points = [
    "Ancient science, decoded with data-backed AI astrology",
    "10M+ charts read, 10K+ classical Vedic rules",
    "Safe. Private. Encrypted.",
  ],
  international = false,
}) => {
  const threads = international ? CHAT_THREADS_INTL : CHAT_THREADS;
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const navigate = useNavigate();
  const { guestChatEnabled } = useGuestChat();

  // Rotating headline topic
  const HERO_WORDS = [
    "deepest questions.",
    "love & marriage.",
    "career & money.",
    "biggest decisions.",
    "true purpose.",
  ];
  const [wordIndex, setWordIndex] = useState(0);
  const [askText, setAskText] = useState("");

  // Chat card rotation: show the question, "think" for a beat, reveal the
  // answer, hold, then move to the next conversation.
  const [threadIndex, setThreadIndex] = useState(0);
  const [thinking, setThinking] = useState(true);
  useEffect(() => {
    const think = setTimeout(() => setThinking(false), 1100);
    const next = setTimeout(() => {
      setThreadIndex((i) => (i + 1) % threads.length);
      setThinking(true);
    }, 6200);
    return () => {
      clearTimeout(think);
      clearTimeout(next);
    };
  }, [threadIndex]);
  useEffect(() => {
    const id = setInterval(
      () => setWordIndex((i) => (i + 1) % HERO_WORDS.length),
      2400
    );
    return () => clearInterval(id);
  }, [HERO_WORDS.length]);

  const handleAsk = (question?: string) => {
    track("Hero Ask Clicked (Hero Section)", {
      source: "Hero Section",
      question: question || "(cta)",
    });
    if (user || guestChatEnabled) {
      // Signed in → the real chat. Non-Indian guest → the chat teaser (ask 1
      // question, blurred answer, sign in to unlock). Indian guest → login sheet.
      navigate("/chat", question ? { state: { heroQuestion: question } } : undefined);
    } else {
      setIsAuthModalOpen(true);
    }
  };

  return (
    <section className="hero-wrapper">
      {/* ===== SPACE BACKGROUND WITH CURVE ===== */}
      <div className="hero-curve-container">
        <div className="hero-bg-image" />
        <div className="hero-overlay" />

        {/* ===== MAIN CONTENT ===== */}
        {/* TWO-COLUMN HERO.
            Previously a centred stack: headline, hook, CTA, and nothing else
            above the fold. No proof, no specifics, and the first thing a
            visitor met was a claim with nothing behind it.

            Left: proof, then the headline, then three concrete specifics, then
            one CTA, then the numbers. Right: the product itself.

            The right column deliberately shows a chat rather than photography.
            Astrotalk puts astrologer portraits there because their product IS
            the astrologers. Ours is the conversation, so we show a real
            question getting a real chart-based answer. It is built in markup
            rather than an image: crisp at any density, themeable, and it adds
            no page weight right after we cut 282 kB of JS. */}
        <div className="hero-content hero-split">
          <div className="hero-col-left">
            {/* Proof first. 4.4 and 1M+ downloads are the live Play
                listing's own figures (2026-10-10). Schema deliberately
                carries no rating, so there is nothing to contradict. */}
            <div className="hero-proof">
              <span className="hero-stars" aria-hidden="true">
                ★★★★★
              </span>
              <span className="hero-proof-score">4.4</span>
              <span className="hero-proof-sep" aria-hidden="true" />
              <span className="hero-proof-text">
                <strong>1M+ downloads</strong> on Google Play
              </span>
            </div>

            <h1 className="hero-title">
              {headingLead}{" "}
              <span className="brand-highlight">{headingAccent}</span>
            </h1>

            {/* The rotating hook, kept: it is the emotional pull that earns
                the CTA tap. Demoted in size now that it is one of several
                elements rather than competing with the H1 for the whole hero. */}
            <p className="hero-subhead">
              Ask Aura AI about your{" "}
              <span className="brand-highlight rotating-word" key={wordIndex}>
                {HERO_WORDS[wordIndex]}
              </span>
            </p>

            {/* Specifics, not adjectives: the method, the scale it runs at,
                and the privacy promise. The figures match StatsMarquee. */}
            <ul className="hero-points">
              {points.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>

            {/* A real input, not just a button: the visitor can start typing
                their question above the fold. Submit routes into the chat via
                the same auth-aware handleAsk the CTA used. */}
            <form
              className="hero-ask-form"
              onSubmit={(e) => {
                e.preventDefault();
                handleAsk(askText.trim() || undefined);
              }}
            >
              <input
                className="hero-ask-input"
                type="text"
                value={askText}
                onChange={(e) => setAskText(e.target.value)}
                placeholder="Ask about career, marriage, money..."
                aria-label="Ask your first question free"
              />
              <button
                type="submit"
                className="hero-cta-button start-chat-button hero-ask-send"
              >
                Ask FREE
              </button>
            </form>

          </div>

          <div className="hero-col-right" aria-hidden="true">
            <div className="hero-chat">
              <div className="hero-chat-head">
                <span className="hero-chat-dot" />
                Aura AI
                <span className="hero-chat-status">
                  {thinking ? "reading your chart" : "online"}
                </span>
              </div>
              {/* Re-keyed on threadIndex so React remounts the messages and the
                  CSS entry animation replays for each new conversation. */}
              <div className="hero-chat-body" key={threadIndex}>
                <p className="hero-msg hero-msg-user">
                  {threads[threadIndex].q}
                </p>
                {thinking ? (
                  <p className="hero-msg hero-msg-ai hero-typing">
                    <span />
                    <span />
                    <span />
                  </p>
                ) : (
                  threads[threadIndex].a.map((line, i) => (
                    <p
                      className="hero-msg hero-msg-ai"
                      key={i}
                      style={{ animationDelay: `${i * 0.5}s` }}
                    >
                      {line}
                    </p>
                  ))
                )}
              </div>
              <div className="hero-chat-foot">
                <span className="hero-chat-input">
                  Ask anything about your chart
                </span>
                <span className="hero-chat-send" aria-hidden="true">
                  →
                </span>
              </div>
              <p className="hero-chat-safe">
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path
                    d="M6 10V8a6 6 0 0 1 12 0v2h.5A1.5 1.5 0 0 1 20 11.5v8A1.5 1.5 0 0 1 18.5 21h-13A1.5 1.5 0 0 1 4 19.5v-8A1.5 1.5 0 0 1 5.5 10H6Zm2 0h8V8a4 4 0 0 0-8 0v2Z"
                    fill="currentColor"
                  />
                </svg>
                Private and encrypted. Ask what you would not say out loud.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ===== PLANETS ROW (Overlapping the curve) ===== */}
      <div className="planets-container">
        <div className="planets-arc">
          {PLANETS_DATA.map((planet, index) => (
            <div className="planet-item" key={index}>
              <div className="planet-gif-wrapper">
                {/* Ensure your GIFs are in public/planets/ */}
                {/* Lazy: these nine animated WebPs total ~1.19MB and were
                    loading eagerly, competing with main.js and the hero image
                    for bandwidth on mobile (audit perf item 1, LCP 16.6s
                    lab). They sit below the fold, so lazy costs nothing. */}
                <img
                  src={planet.gif}
                  alt={planet.name}
                  className="planet-gif"
                  loading="lazy"
                  decoding="async"
                  width={200}
                  height={200}
                />
              </div>
              <span className="planet-label">
                <span className="planet-name-en">{planet.name}</span>
                <br />
                <span className="planet-name-local">
                  {planet.label.split("(")[1]?.replace(")", "") || ""}
                </span>
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Auth Modal */}
      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
        onGoogleSignIn={onGoogleSignIn}
        phoneAuth={phoneAuth}
        msg91Auth={msg91Auth}
      />
    </section>
  );
};

export default HeroSection;
